const ModalEliminar = ({onId}) => {
    return (
        <div
            className="modal fade"
            id="exampleModalView"
            tabIndex={-1}
            aria-labelledby="exampleModalViewLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog modal-dialog-centered">
                <div className="modal-content radius-16 bg-base">
                    <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                        <h1 className="modal-title fs-5" id="exampleModalViewLabel">
                            ¿Estás seguro de eliminar?
                        </h1>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        />
                    </div>
                    <div className="modal-body p-24">
                        <div className="mb-12">
                            <span className="text-secondary-light txt-sm fw-medium">Al aceptar, no podrás deshacer esta acción.</span>
                            {/* <h6 className="text-primary-light fw-semibold text-md mb-0 mt-4">
                                Design Conference
                            </h6> */}
                        </div>
                        
                        <div className="col-12 d-flex justify-content-between">
                            <button type="button" data-bs-dismiss="modal" aria-label="Close" className="btn btn-secondary">Cancelar</button>
                            <button type="button" className="btn btn-danger" onClick={onId} data-bs-dismiss="modal" aria-label="Close">Aceptar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default ModalEliminar;